import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { Extensions } from '@powdr/constants';
import { getFileExtension } from '@powdr/utils';

import {
  StyledOrderedShowcaseItem, ImageWrapper, Image,
} from './styles';

export const OrderedShowcaseItem = ({
  className = '',
  active,
  relationships = {},
  onClick = null,
  clickable = false,
  itemSizeLimit = null,
}) => {
  const [lottie, setLottie] = useState(null);
  const showcaseIconData = relationships?.showcaseIcon || null;
  const fileExtension = getFileExtension(showcaseIconData?.filename);

  useEffect(() => {
    if (!lottie) return;
    if (active) {
      lottie.play();
    } else {
      lottie.stop();
    }
  }, [active, lottie]);

  if (!showcaseIconData?.url || !showcaseIconData?.publicUrl) return null;

  return (
    <StyledOrderedShowcaseItem
      className={className}
      onClick={onClick}
      $clickable={clickable}
    >
      <ImageWrapper $itemSizeLimit={itemSizeLimit}>
        {(fileExtension === Extensions.JSON || fileExtension === Extensions.LOTTIE) ? (
          <DotLottieReact
            dotLottieRefCallback={setLottie}
            src={showcaseIconData.url}
            loop
            autoplay={active}
            renderConfig={{ autoResize: true }}
          />
        ) : (
          <Image $itemSizeLimit={itemSizeLimit} alt="" src={showcaseIconData?.url} />
        )}
      </ImageWrapper>
    </StyledOrderedShowcaseItem>
  );
};

OrderedShowcaseItem.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  relationships: PropTypes.shape({}),
  onClick: PropTypes.func,
  clickable: PropTypes.bool,
  itemSizeLimit: PropTypes.number,
};
